import { disableSubmitButton } from "../js/popups/activate_forms";
import { AffiliateProduct, getTrackingValues, setValueToBrowser } from "../js/trackingQueryHook";
import { birthDay, birthMonth, birthYear } from './validate_birthday';
import { loginRegistrationAdditionalHeaders } from "./utils";
import { getSiteApi, initializeSession, redirectAfterRegistration } from "../js/session";
import { internalSetCookie } from "../js/cookies";
import { handleError } from "./errorHandler";

export const registration = async (data) => {
    const signUpSubmitButton = document.getElementById('signup-form-submit-button');
    let sessionId = null;
    if(window?.seon) {
        sessionId = await window.seon.getBase64Session();
    }

    const birthDate = new Date(
        Date.UTC(birthYear, birthMonth - 1, birthDay, 0, 0, 0)
    );
    const formData = {
        email: data.target[0].value.trim(),
        password: data.target[1].value,
        phoneCode: '+52',
        phoneNumber: data.target[3].value,
        isPushNewsletter: data.target[4].checked,
        isPhoneNewsletter: data.target[4].checked,
        isEmailNewsletter: data.target[4].checked,
        allowPromotions: data.target[4].checked,
        firstName: data.target[5].value.trim(),
        lastName: data.target[6].value.trim(),
        promoCode: data.target[10].value,
        birthDate,
    }
    const address = {
        street: '',
        city: '',
        zipCode: '',
        colonyMX: '',
        addressCountryAlfa2: '--',
    };
    const phone = `${formData.phoneCode}${formData.phoneNumber}`;
    const signUpPopup = data.target.closest('.is__open');
    const product = signUpPopup.dataset.sport ? AffiliateProduct.Sport : AffiliateProduct.Casino;

    const profileData = {
        language: 'es',
        address,
        gender: 'other',
        birthDate: formData.birthDate,
        firstName: formData.firstName,
        lastName: formData.lastName,
        middleName: '',
        password: formData.password,
        ...(formData.nickName && { nickName: formData.nickName.trim() }),
        isPushNewsletter: formData.isPushNewsletter,
        isPhoneNewsletter: formData.isPhoneNewsletter,
        isEmailNewsletter: formData.isEmailNewsletter,
        allowPromotions: formData.allowPromotions,
        citizenship: 'MX',
        email: formData.email,
        phone,
        currency: 'MXN',
        affiliateInformation: getTrackingValues(data?.target[10].value, product),
        emailVerified: false,
        phoneVerified: false,
        country: undefined,
        city: undefined,
        zipCode: undefined,
        fingerprint: sessionId,
    };

   if (signUpSubmitButton.disabled === false) {
        try {
            disableSubmitButton(signUpSubmitButton, true);
            fetch(`${getSiteApi()}player/crm/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...loginRegistrationAdditionalHeaders()
                },
                body: JSON.stringify(profileData)
            })
                .then((response) => {
                    if (!response.ok) {
                        // If response is not ok, parse the response to get the error details
                        return response.json().then(error => {
                            return Promise.reject(error);
                        });
                    }
                    return response.json();
                })
                .then((response) => {
                    initializeSession(response);
                    localStorage.setItem('email', response?.email);
                    localStorage.setItem('userId', response?.id);
                    internalSetCookie('isRegistration', 'done', 10);
                    internalSetCookie('shouldRecieveBonus', response?.isOptBonusAvailable?.toString(), 10);
                    setValueToBrowser('product', response?.product?.toString());
                    redirectAfterRegistration();
                })
                .catch((e) => {
                    console.log(e)
                    const { message, statusCode } = e;
                    const signUpErrorContainer = document.querySelector('.signup-submit-error');
                    if (
                        statusCode === 403 ||
                        message?.includes('rejected')
                    ) {
                        handleError('Algo salió mal. Por favor contacte con soporte.', signUpErrorContainer)
                    } else if (message.includes('duplicate')) {
                            const errorField = message.replace('duplicate.', '').split('.').join(', ');
                            handleError(`Este ${errorField} ya existe`, signUpErrorContainer)
                    } else {
                            console.log('[Error]', message);
                    }
                })
                .finally(() => {
                    disableSubmitButton(signUpSubmitButton, false);
                });
        } catch (e) {
            console.log('[Error]', e?.message || e);
            disableSubmitButton(signUpSubmitButton, false);
        }
    }
}
